module.exports = __webpack_public_path__ + "img/7.57666535.jpg";